const activateCategoryPane = (menu, target) => {
  const tabs = menu.querySelectorAll('[data-category-tab]');
  const panes = menu.querySelectorAll('[data-category-pane]');

  tabs.forEach((tab) => {
    const isActive = tab.getAttribute('data-category-tab') === target;
    tab.classList.toggle('is-active', isActive);
    tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
  });

  panes.forEach((pane) => {
    const isActive = pane.getAttribute('data-category-pane') === target;
    pane.classList.toggle('is-active', isActive);
    pane.toggleAttribute('hidden', !isActive);
  });
};

const setupCategoryMenus = (root = document) => {
  root.querySelectorAll('[data-category-menu]').forEach((menu) => {
    if (menu.dataset.categoryMenuReady === 'true') return;
    menu.dataset.categoryMenuReady = 'true';

    menu.querySelectorAll('[data-category-tab]').forEach((tab) => {
      const target = tab.getAttribute('data-category-tab');
      if (!target) return;

      tab.addEventListener('pointerenter', () => activateCategoryPane(menu, target));
      tab.addEventListener('focus', () => activateCategoryPane(menu, target));
      tab.addEventListener('click', () => activateCategoryPane(menu, target));
    });
  });
};

setupCategoryMenus();

document.addEventListener('shopify:section:load', (event) => {
  setupCategoryMenus(event.target);
});
